import React, { useEffect } from "react";

export default function PortalTab({ shop }) {
    useEffect(() => {
        const container = document.getElementById("widget-booking");

        if (!container) return;

        container.innerHTML = "";

        const script = document.createElement("script");
        script.src = "https://localhost:44488/widget/booking.js";
        script.dataset.clientId = shop.apiKey;

        container.appendChild(script);

        return () => {
            container.innerHTML = "";
        };
    }, [shop.apiKey]);

    return (
        <div className="hk-card">
            <div id="widget-booking" />
        </div>
    );
}
